// Backstop for persisted teaser job errors rendered in the UI. Failed jobs
// written before backend write-time sanitization (see
// backend/functions/src/utils/sanitizeUserFacingError.ts) may still carry raw
// internal strings — provider/model names, env-var names, JSON-parse dumps —
// so map them to friendly copy at render time.

// BUG 1 backstop: never show a raw JSON.parse/SyntaxError to the user — including
// older failed jobs whose raw error string was already persisted to Firestore.
const RAW_PARSE_ERROR = /position\s+\d+|SyntaxError|Unexpected (token|end of)|JSON/i;

// Mirrors the backend sanitizer's provider/env-var patterns (CLAUDE.md rule:
// no AI model names in UI).
const RAW_INTERNAL_ERROR =
  /\w*API_KEY\w*|not configured|\b(Anthropic|Claude|Sonnet|Opus|Haiku|Fable|Gemini|GPT[-\w]*|OpenAI|Vertex)\b/i;

export const FRIENDLY_TEASER_FAILURE =
  'Quick screen failed — the teaser output was incomplete. Please try again, or select fewer source files.';

export const GENERIC_TEASER_FAILURE =
  'AI analysis could not be completed. Please try again — the team has been notified.';

export function toFriendlyTeaserError(
  message?: string | null,
  fallback: string = 'Quick screen failed.'
): string {
  if (!message) return fallback;
  if (RAW_PARSE_ERROR.test(message)) return FRIENDLY_TEASER_FAILURE;
  if (RAW_INTERNAL_ERROR.test(message)) return GENERIC_TEASER_FAILURE;
  return message;
}
